import styled, { css } from "styled-components";

export const _SizeViewContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

// Desktop only: on mobile the preview scrolls away and PreviewBar takes over,
// so nothing changes document height in response to scrolling.
const stickySection = css`
  @media (min-width: 768px) {
    position: sticky;
    align-self: flex-start;
    top: 100px;
    z-index: 1;
  }
`;

export const _LayoutSectionSizeView = styled.div`
  position: relative;

  @media (min-width: 768px) {
    width: 45%;
    padding-top: 45px;
  }

  @media (min-width: 1200px) {
    width: initial;
    flex-basis: ${(props) => props.basis || "45%"};
  }

  ${(props) => props.sticky && stickySection}
`;

export const _NavigationContainer = styled.div`
  padding: 0px 20px;
`;

export const _VerticalSeparator = styled.div`
  width: 1px;
  background: lightgrey;
`;
